import styled from 'styled-components';

const StyledArticleProducts = styled.article`
  position: relative;
  margin-bottom: ${props => props.theme.components_spacing_desk.large}px;
  padding-right: 64px;
  padding-left: 64px;
  z-index: 3;
  &.line-end-trigger {
    margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  }
  p.intro--article{
    padding-bottom: ${props => props.theme.components_spacing_desk.medium}px;
    letter-spacing: 0;
    line-height: 130%;
    margin: 0 auto;
    max-width: 66.66%;
    text-align: center;
    padding-top: ${props => props.extraPadding ? '150' : '0'}px;
  }
  p.intro--article span{
    color: ${ props => props.theme.colors.green_secondary};
  }
  .article--figure{
    position: relative;
    height: auto;
    margin-bottom: 80px;
    overflow: hidden;
    padding-top: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  .article--figure img{
    position: relative;
    display: block;
    width: 100%;
    transform-origin: 50%;
  }
  &.align-left{
    .article--figure, .article--wrap{
      margin-right: auto;
      margin-left: 0;
    }
  }
  &.align-right{
    .article--figure, .article--wrap{
      margin-left: auto;
      margin-right: 0;
    }
  }
  .figure--11{
    width: 91.63%;
  }
  .figure--9{
    width: 74.97%;
  }
  .figure--7{
    width: 58.31%;
  }
  .figure--5{
    width: 41.65%;
  }
  .article--wrap{
    position: relative;
    width: 41.65%;
  }
  .article--wrap .article--text{
    color: ${props => props.theme.colors.grey_700};
    margin: 24px 0;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.large}px;
    &.line-end-trigger {
      margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
    p.intro--article{
      padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
      max-width: 83.33%;
    }
    .article--figure{
      padding-top: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.large}px;
    &.line-end-trigger {
      margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    }
    p.intro--article{
      padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
      max-width: 100%;
      padding-top: 0
    }
    .figure--11, .figure--9, .figure--7, .figure--5, .article--wrap{
      width: 100%;
    }
    .article--wrap{
      text-align: center;
    }
    .article--wrap .article--text{
      margin-bottom: 0;
    }
    .article--figure{
      padding-top: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
  }
`;

export {
  StyledArticleProducts,
};

